module.exports = __webpack_public_path__ + "media/02_homepage 3 slow.webm";